import config from '../config/index';
import md5 from 'md5';
/* eslint-disable */

window.WebSocket = window.WebSocket || window.MozWebSocket;

const messageHandler = async (context, message) => {
  cleanUp();

  let data = null;
  try {
    data = JSON.parse(message.data);
  } catch (e) {}
  if (data === null) {
    return;
  }

  if (typeof data.id !== 'undefined') {
    let request = state.requests.find(r => r.id == data.id);
    if (typeof request !== 'undefined') {
      request.callback(data);
      request.dieIn = 0;
      return cleanUp();
    }
  }
  if (data.action == 'update') {
    if(data.success == false) {
      // context.commit('authChecker', 'failed');
    } else {
      // context.commit('authChecker', 'update');
      // data.data.events.forEach(el => {
        // context.dispatch('eventsMergeSearchEvents', [el]);
        // context.dispatch('eventsMergeMyFeedEvents', [el]);
        // el.channel.forEach(cha => {
        //   context.dispatch('eventsMergeOtherFeedEvents', {'events': [el], 'channel': cha.toLowerCase()});
        // })
      // })
    }
  }
};

const addRequest = (action, data, callback) => {
  const nowStamp = new Date().getTime();
  const dieIn = nowStamp + 6000;
  const id = md5(nowStamp);
  state.requests.push({
    dieIn,
    id,
    action,
    data,
    callback,
  });
  state.connection.send(JSON.stringify({
    action,
    id,
    data,
  }));
  cleanUp();
};

const cleanUp = () => {
  let now = new Date().getTime();
  state.requests = state.requests.filter(request => request.dieIn > now);
};

const state = {
  connection: null,
  requests: []
};

const getters = {
  serverConnection(state) {
    return state.connection;
  },
  serverIsConnected(state) {
    return state.connection !== null && state.connection.readyState === state.connection.OPEN;
  }
};

const mutations = {
  serverConnect(state, connection) {
    state.connection = connection;
  },
  serverDisconnect(state) {
    state.connection = null;
  }
};
const webSocketURL =  {
  testing: `ws://${config.server.url}:${config.server.port}/`,
  development:`wss://${config.server.url}:${config.server.port}/`,
  dev: `wss://${config.server.url}:${config.server.port}/`,
  staging: `wss://${config.server.url}:${config.server.port}/`,
  production: `wss://${config.server.url}:${config.server.port}/`
};

const actions = {
  serverConnect(context) {
    // console.log('websocketURL', webSocketURL[config.environment])
    // console.log('websocketURL', config)
    let connection = new WebSocket(webSocketURL[config.environment]);
    connection.onopen = () => {
      context.commit('serverConnect', connection);
      context.dispatch('serverAfterConnect');
      // context.dispatch('eventsLoad');
    };
    // connection.onerror = error => console.log('error');
    connection.onclose = () => {
      context.commit('serverDisconnect');
      setTimeout(() => context.dispatch('serverConnect'), 3000);
    };
    connection.onmessage = message => messageHandler(context, message);
  },
  serverDisconnect(context) {
    context.state.connection.close;
  },
  serverRequest(context, payload) {
    return Promise.race([
      //eslint-disable-next-line
      new Promise((rs, rj) => addRequest(payload.action, payload.data, returnData => rs(returnData))),
      new Promise((rs, rj) => setTimeout(() => rj('Timed out'), 5000))
    ]);
  },
  serverSend(context, message) {
    if (!context.getters.serverIsConnected) {
      return;
    }
    context.getters.serverConnection.send(JSON.stringify(message));
  },
  authAfterLogin(context) {
    context.dispatch('serverConnect');
  }
};

export default {
  state,
  getters,
  mutations,
  actions
};
